import React, { useContext, useEffect } from "react";
import { useLocation, NavLink, useNavigate } from "react-router-dom";
import AuthContext from "../../store/auth-context";
import Settings from "../../resources/icons/setting-4.svg";
import Transactions from "../../resources/icons/folder-favorite.svg";
import Verify from "../../resources/icons/brush.svg";
import VpIcon from "../../resources/icons/id-card.svg";
import AppConstants from "../../configs/AppConstants";
import useSidebarNavigation from "../../hooks/useSidebarNavigation";
import { useTranslation } from "react-i18next";

const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const authContext = useContext(AuthContext);
  const { t } = useTranslation();

  const handleIssuedClick = (e) => {
    e.preventDefault();
    authContext.IssuedOffsetHandler(0);
    localStorage.setItem("transactionOffset", 0);
    navigate("/verifier/transaction/all");
  };

  const allNavItems = {
    Verify: {
      navId: "sidebar-verify-nav-link",
      name: t("sidebar:verify"),
      to: "/verifier/validate",
      match: {
        type: "partial",
        path: "/verifier/validate",
      },
      icon: Verify,
      disabledIcons: Verify,
      allowedRoles: ["admin", "admin_verifier", "verifier"],
    },
    Transactions: {
      navId: "sidebar-transactions-nav-link",
      name: t("sidebar:transactions"),
      to: "/verifier/transaction/all",
      match: {
        type: "partial",
        path: "/verifier/transaction/",
      },
      icon: Transactions,
      disabledIcons: Transactions,
      onClick: handleIssuedClick,
      allowedRoles: ["admin", "admin_verifier", "verifier"],
    },
    Request: {
      navId: "sidebar-request-nav-link",
      name: t("sidebar:request"),
      to: "/verifier/vp/category",
      match: {
        type: "partial",
        path: "/verifier/vp/",
      },
      icon: VpIcon,
      disabledIcons: VpIcon,
      allowedRoles: ["admin", "admin_requester"],
    },
    Settings: {
      navId: "sidebar-settings-nav-link",
      name: t("sidebar:settings"),
      to: "/verifier/settings",
      match: {
        type: "partial",
        path: "/verifier/settings",
      },
      icon: Settings,
      disabledIcons: Settings,
      allowedRoles: ["admin", "admin_requester"],
    },
  };

  const isPasswordResetPage = location.pathname.startsWith(
    "/users/update-password"
  );

  const isIIITB = AppConstants.TRUSTED_IIITB_HOSTS.includes(
    window.location.origin
  );

  const { sidebarComponents, fetchCurrentUser } =
    useSidebarNavigation(allNavItems);

  useEffect(() => {
    if (authContext.isLoggedIn) {
      fetchCurrentUser();
    }
  }, [authContext.isLoggedIn]);

  const filteredNavs = (Array.isArray(sidebarComponents) ? sidebarComponents : [])
    .filter(
      (key) =>
        allNavItems[key] &&
        allNavItems[key].allowedRoles.includes(authContext.userType)
    )
    .map((key) => allNavItems[key]);

  const finalNavs = filteredNavs;

  if (isPasswordResetPage) {
    return null;
  }

  return (
    <div className="flex flex-col gap-3 h-full bg-cfSecondary overflow-y-auto items-center py-3 w-[7rem] border-r-[1.5px]">
      <div
        className={`w-full ${
          finalNavs.length > 1 ? "justify-between" : "justify-start"
        }`}
      >
        <div className="w-full flex flex-col font-CfSecondaryFont gap-y-4">
          {finalNavs.map(
            ({ name, to, match, icon, onClick, navId }, index, currentArray) => (
              <>
                {((currentArray.length > 1 &&
                  !(index === currentArray.length)) ||
                  currentArray.length === 1) &&
                  name !== "" && (
                    <NavLink
                      id={navId}
                      key={name}
                      to={to}
                      title={name}
                      className={`flex w-full font-CfPrimaryFont text-sm capitalize py-2 bg-opacity-40 hover:text-cfPrimaryLight hover:no-underline`}
                      onClick={onClick}
                    >
                      <div
                        className={`h-14 w-1 absolute left-0  ${
                          ((match.type === "exact" &&
                            location.pathname === match.path) ||
                            (match.type === "partial" &&
                              location.pathname.startsWith(match.path))) &&
                          "bg-cfPrimary"
                        }`}
                      />
                      <div
                        className={`w-full flex flex-col items-center gap-3 justify-center ${
                          ((match.type === "exact" &&
                            location.pathname === match.path) ||
                            (match.type === "partial" &&
                              location.pathname.startsWith(match.path))) &&
                          "font-semibold"
                        }`}
                      >
                        <img src={icon} alt="" className="w-6" />
                        {name}
                      </div>
                    </NavLink>
                  )}
              </>
            )
          )}
        </div>
      </div>
      {/* {authContext.isLoggedIn ? (
        <div className="h-xs:absolute bottom-20">
          <NavLink
            to={issuer_navs[issuer_navs.length - 1].to}
            title={issuer_navs[issuer_navs.length - 1].name}
            className={`flex w-full font-CfPrimaryFont text-sm capitalize py-2 bg-opacity-40 hover:text-cfPrimaryLight hover:no-underline`}
          >
            <div
              className={`h-14 w-[0.360rem] absolute -left-4 ${
                ((issuer_navs[issuer_navs.length - 1].match.type === "exact" &&
                  location.pathname ===
                    issuer_navs[issuer_navs.length - 1].match.path) ||
                  (issuer_navs[issuer_navs.length - 1].match.type ===
                    "partial" &&
                    location.pathname.startsWith(
                      issuer_navs[issuer_navs.length - 1].match.path
                    ))) &&
                "bg-cfPrimaryCardHover"
              }`}
            />
            <div
              className={`w-full flex flex-col items-center justify-center  ${
                ((issuer_navs[issuer_navs.length - 1].match.type === "exact" &&
                  location.pathname ===
                    issuer_navs[issuer_navs.length - 1].match.path) ||
                  (issuer_navs[issuer_navs.length - 1].match.type ===
                    "partial" &&
                    location.pathname.startsWith(
                      issuer_navs[issuer_navs.length - 1].match.path
                    ))) &&
                "font-semibold"
              }`}
            >
              <img
                src={issuer_navs[issuer_navs.length - 1].icon}
                alt=""
                className="w-6"
              />
              {issuer_navs[issuer_navs.length - 1].name}
            </div>
          </NavLink>
        </div>
      ) : (
        ""
      )} */}
    </div>
  );
};

export default Sidebar;
